import {Table} from "antd";
import styled from "styled-components";

/**
 * Açılır (expandable) tablolarda kullanılmak üzere genel stil bileşeni.
 * Mobilde kart düzeni, data-label ile etiketler ve açılan satır stillerini uygular.
 * Kullanım: columns'da onCell: (record) => ({ "data-label": "Sütun Başlığı" }) verin.
 */
export const ExpandableStyledTable = styled(Table)`
    width: 100%;
    max-width: 100%;

    .ant-table-thead > tr > th {
        font-size: 14px;
        font-weight: 600;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
    }

    @media screen and (max-width: 768px) {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;

        .ant-table-wrapper,
        .ant-spin-nested-loading,
        .ant-spin-container,
        .ant-table,
        .ant-table-container,
        .ant-table-content {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
        }

        .ant-table {
            overflow-x: visible;
        }

        .ant-table table {
            min-width: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            table-layout: auto;
        }

        .ant-table-thead > tr > th,
        .ant-table table th {
            display: none !important;
        }

        .ant-table table thead,
        .ant-table table tbody {
            width: 100% !important;
        }

        colgroup {
            display: none;
        }

        .ant-table table td:not(.ant-table-row-expand-icon-cell) {
            display: grid !important;
            grid-template-columns: minmax(0, 42%) minmax(0, 1fr);
            column-gap: 14px;
            row-gap: 6px;
            align-items: start;
            justify-items: stretch;
            padding: 14px 16px !important;
            border-bottom: 1px solid #f0f0f0;
            font-size: 14px;
            min-height: 48px;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box;
            min-width: 0;
            overflow: visible;
        }

        .ant-table table td.ant-table-row-expand-icon-cell {
            padding: 8px;
            width: 60px;
            min-width: 60px;
            max-width: 60px;
            display: flex !important;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #f0f0f0;
        }

        .ant-table table td.ant-table-row-expand-icon-cell::before {
            display: none;
        }

        .ant-table table td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #333;
            text-align: left;
            grid-column: 1;
            justify-self: start;
            font-size: 14px;
            min-width: 0;
            max-width: 100%;
            display: block;
            line-height: 1.5;
            word-break: break-word;
            overflow-wrap: break-word;
        }

        .ant-table table td[data-label=""]::before,
        .ant-table table td:not([data-label])::before {
            display: none;
        }

        .ant-table table td:not([data-label]):not(.ant-table-row-expand-icon-cell) {
            grid-template-columns: minmax(0, 1fr);
        }

        .ant-table table td:not([data-label]):not(.ant-table-row-expand-icon-cell) > * {
            grid-column: 1;
            justify-self: stretch;
            text-align: left;
        }

        .ant-table table td:not(.ant-table-row-expand-icon-cell) > * {
            grid-column: 2;
            justify-self: end;
            text-align: right;
            min-width: 0;
            max-width: 100%;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-word;
            white-space: normal;
            line-height: 1.5;
            overflow: visible;
        }

        .ant-table table tbody tr {
            display: block;
            margin-bottom: 20px;
            background: white;
            border-radius: 12px;
            border: 1px solid #e8e8e8;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td:not(.ant-table-row-expand-icon-cell) {
            border-bottom: 1px solid #f5f5f5;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td:first-child {
            padding-top: 16px !important;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
        }

        .ant-table table tbody tr td:last-child {
            padding-bottom: 16px !important;
            border-bottom: none;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        .ant-table-expanded-row + .ant-table-row td:first-child,
        .ant-table-row.ant-table-row-level-0.ant-table-expanded-row-level-1 td:first-child {
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
        }

        .ant-table-row-level-0:has(+ .ant-table-expanded-row) td:last-child {
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            border-bottom: 1px solid #f0f0f0 !important;
        }

        .ant-table-expanded-row > td {
            padding: 0 !important;
            display: block !important;
            background-color: #f8f9fa;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            overflow: visible !important;
        }

        .ant-table-expanded-row > td.ant-table-cell {
            border-top: 1px solid #f0f0f0;
        }

        .ant-table-expanded-row > td::before {
            display: none !important;
        }

        .ant-table-expanded-row .ant-table-expanded-row-content {
            padding: 12px 16px !important;
            background-color: transparent;
            border-radius: 0;
            margin: 0;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            overflow-x: auto !important;
            overflow-y: visible !important;
            -webkit-overflow-scrolling: touch;
        }

        /* Açılan içerikteki iç tablo: taşmayı önle, yatay kaydırma ile tam görünsün */
        .ant-table-expanded-row .ant-table-expanded-row-content .ant-table-wrapper {
            max-width: 100% !important;
            width: 100% !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
        }

        .ant-table-expanded-row .ant-table-expanded-row-content .ant-table {
            min-width: 0 !important;
        }

        .ant-table-expanded-row .ant-table-expanded-row-content .ant-table-content {
            overflow-x: auto !important;
        }

        .ant-table-expanded-row {
            background: white;
            margin-bottom: 20px;
            display: block;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
        }

        .ant-table-expanded-row:hover > td {
            background: #f8f9fa;
        }

        .ant-table tbody tr.ant-table-row-level-0:not(.ant-table-expanded-row) {
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        .ant-table tbody tr.ant-table-row-level-0:has(+ .ant-table-expanded-row) {
            margin-bottom: 0;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        .ant-table tbody .ant-table-expanded-row {
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            width: 100% !important;
            max-width: 100% !important;
        }

        .ant-table-tbody > tr:hover > td {
            background: #fafafa;
        }

        .ant-table-row-expand-icon {
            color: #000;
            position: relative;
            border: none;
        }

        .ant-table-row-expand-icon:hover {
            color: #000;
            border: none;
        }

        .ant-table-row-expand-icon > .anticon {
            display: none;
        }

        .ant-table-row-expand-icon::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 14px;
            height: 2px;
            background-color: #000;
        }

        .ant-table-row-expand-icon::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 2px;
            height: 14px;
            background-color: #000;
            transition: transform 0.2s ease, opacity 0.2s ease;
        }

        .ant-table-row-expand-icon-expanded::after {
            transform: translate(-50%, -50%) rotate(90deg);
            opacity: 0;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-table table td:not(.ant-table-row-expand-icon-cell) {
            font-size: 13px;
            padding: 12px 14px !important;
            grid-template-columns: minmax(0, 46%) minmax(0, 1fr);
            column-gap: 10px;
        }

        .ant-table table td::before {
            font-size: 13px;
        }
    }
`;
